import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

import { PipesModule } from '@shared/pipes/pipes.module';
import { IconComponent } from '@ui-components/components/icon/icon.component';
import { InputErrorModule } from '@ui-components/components/input-error/input-error.module';

import { RadioButtonComponent } from './radio-button.component';

@NgModule({
  declarations: [RadioButtonComponent],
  imports: [
    CommonModule,
    MatRadioModule,
    MatButtonModule,
    IconComponent,
    MatTooltipModule,
    ReactiveFormsModule,
    PipesModule,
    InputErrorModule,
  ],
  exports: [RadioButtonComponent],
})
export class RadioButtonModule {}
